import DomainIcon from "@material-ui/icons/Domain";
import BusinessRelationshipTypeList from "./BusinessRelationshipTypeList";

export default {
  list: BusinessRelationshipTypeList,
  icon: DomainIcon,
};
